export default "__VITE_ASSET__chdr6_hYXDsxeCCQgt8tTw__"